module.exports = __webpack_public_path__ + "static/media/swsx.55838013.glb";


//////////////////
// WEBPACK FOOTER
// ./src/constants/swsx.glb
// module id = 94
// module chunks = 0